import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // בודק אם המשתמש כבר אישר את הקוקיס
    const hasConsent = localStorage.getItem('cookieConsent');
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 md:p-6 shadow-lg z-50"
      style={{
        animation: 'slideUp 0.5s ease-out',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8">
          <div className="text-center md:text-right flex-grow">
            <p className="text-sm sm:text-base lg:text-lg leading-relaxed">
              אנחנו משתמשים בקוקיס כדי לשפר את חווית המשתמש שלך באתר.
              המשך הגלישה באתר מהווה הסכמה{' '}
              <Link 
                to="/privacy-policy"
                className="underline hover:text-blue-300 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 focus:ring-offset-gray-900 rounded-sm"
              >
                למדיניות הפרטיות
              </Link>{' '}
              שלנו.
            </p>
          </div>
          <div className="flex justify-center md:justify-end w-full md:w-auto">
            <button
              onClick={handleAccept}
              className="w-full sm:w-auto min-w-[120px] bg-white text-gray-900 px-6 py-3 rounded-lg text-base font-medium 
                hover:bg-gray-100 active:bg-gray-200 
                transition-all duration-200 
                focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-900
                transform hover:scale-105 active:scale-100"
            >
              מסכים
            </button>
          </div>
        </div>
      </div>
      <style>
        {`
          @keyframes slideUp {
            from {
              transform: translateY(100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }

          @media (max-width: 640px) {
            .cookie-consent-enter {
              transform: translateY(100%);
            }
            .cookie-consent-enter-active {
              transform: translateY(0);
              transition: transform 0.3s ease-out;
            }
            .cookie-consent-exit {
              transform: translateY(0);
            }
            .cookie-consent-exit-active {
              transform: translateY(100%);
              transition: transform 0.3s ease-in;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CookieConsent; 